import {inject, Injectable, Injector} from '@angular/core';
import posthog from 'posthog-js';
import {v4 as uuidv4} from 'uuid';
import {AuthService} from "./auth.service";
import {environment} from "../../../environments/environment";

@Injectable({
    providedIn: 'root'
})
export class PosthogService {
    private sessionId: string;
    private serviceEnabled: boolean = false;
    private injector = inject(Injector);

    constructor() {
        this.sessionId = uuidv4();

        const apiKey = environment.posthog?.apiKey;
        if (!apiKey) return;

        this.serviceEnabled = true;
        posthog.init(apiKey, {
            api_host: environment.posthog.apiHost,
            autocapture: true,
            capture_exceptions: true,
            disable_session_recording: false,
            disable_cookie: true,
            disable_persistence: true
        });

        posthog.identify(this.sessionId);
    }

    private get authService(): AuthService {
        return this.injector.get(AuthService);
    }

    capture(event: string, properties: Record<string, any> = {}) {
        if (!this.serviceEnabled) return;
        const companyName = this.authService.companyData?.companyInfo?.brandName;
        properties['tenant'] = companyName || 'Unknown Company';
        properties['random'] = Math.random().toString(36).substring(2, 15);
        posthog.capture(event, properties);
    }

    captureException(error: unknown, properties: Record<string, any> = {}) {
        if (!this.serviceEnabled) return;
        const companyName = this.authService.companyData?.companyInfo?.brandName;
        properties['tenant'] = companyName || 'Unknown Company';
        posthog.captureException(error, properties);
    }

    getSessionId() {
        return this.sessionId;
    }
}
